import { FONT, hexA } from "../theme";
import { statusMeta } from "./meta";
import type { Zone } from "../types";

/** Colored status pill driven by the zone's state, with a pulsing dot while watering. */
export function Pill({ z, big = false }: { z: Zone; big?: boolean }) {
  const m = statusMeta(z.state);
  const dot = big ? 6 : 5;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 7,
        borderRadius: 999,
        background: hexA(m.color, 0.16),
        border: `1px solid ${hexA(m.color, 0.34)}`,
        color: `color-mix(in srgb, ${m.color}, var(--ink) 32%)`,
        padding: big ? "5px 12px" : "4px 10px",
        fontFamily: FONT.sans,
        fontSize: big ? 12 : 11,
        fontWeight: 600,
        lineHeight: 1.1,
        whiteSpace: "nowrap",
      }}
    >
      <m.Icon size={big ? 13 : 11} strokeWidth={2.4} />
      {m.label}
      {z.state === "watering" && (
        <span
          className="dot-pulse"
          style={{
            width: dot,
            height: dot,
            borderRadius: 9,
            background: m.color,
          }}
        />
      )}
    </span>
  );
}
